<template>
  <AppButton
    color="tertiary"
    large
    :dark="true"
    class="polyOfficeIconParent"
    data-locator="import-from-poly-button"
    @click="handleClick"
  >
    <app-icon-poly-office color="white" class="mr-1" />
    {{ $t('common.polyOffice.PolyOfficeButtonImport.importFiles') }}
  </AppButton>
</template>

<script>
import AppButton from '@/common/buttons/AppButton.vue'

export default {
  name: 'PolyOfficeButtonImport',
  components: { AppButton },
  methods: {
    handleClick () {
      this.$emit('polyOfficeOpenDialog')
    },
  },
}
</script>
